import React, { Component } from "react";
import "./App.css";
import Main from "./containers/Main/Main";
import Login from "./components/Login/Login";
import { Container } from "semantic-ui-react";
import HeaderMenu from "./components/HeaderMenu/HeaderMenu";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from "react-router-dom";

class App extends Component {
  state = {
    googleErrors: {},
    user: {},
    token: null,
    isAuthenticated: false,
    isLoading: false
  };

  populateUserData = response => {
    let userData = response.profileObj;
    let token = response.tokenObj.access_token;
    localStorage.setItem("token", token);
    this.setState({
      ...this.state,
      user: userData,
      token: token,
      isAuthenticated: true,
      isLoading: false
    });
  };

  responseGoogle = response => {
    this.setState({
      ...this.state,
      googleErrors: response.data,
      isLoading: false
    });
    console.log(response);
  };

  render() {
    let routes = (
      <Switch>
        <Route  
          exact
          path="/login"
          render={(props) => (
            <Login
              loadUser={this.populateUserData}
              loginError={this.responseGoogle}
              isAuth={this.state.isAuthenticated}
              token={this.state.token}
            />
          )}
        />
        <Redirect to="/login" />
      </Switch>
    );

    if (this.state.isAuthenticated) {
      routes = <Switch>
          <Route path="/" render={props => <Main {...props} token={this.state.token} user={this.state.user} />} />
          <Redirect to="/" />
        </Switch>;
    }

    return (
      <Router>
        <main className="App">
          <HeaderMenu isAuthenticated={this.state.isAuthenticated} user={this.state.user} />
          <Container className="Main">{routes}</Container>
        </main>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js